import React, { Component } from 'react';
import Emitter from 'app/blocks/common/events/emitter';
import Events from 'app/blocks/common/events/Events';
import withPreloading from 'app/blocks/common/with-preloading-hoc';
import { getUser } from 'app/blocks/middleware/authentication';
import ProfileOrcidConnector from 'app/blocks/orcid/ProfileOrcidConnector';
import Orcid from './Orcid';
import * as middlewareProfile from '../middleware/profile';

class ProfileOrcid extends Component {
    connector = new ProfileOrcidConnector();

    componentDidMount() {
        this.connector.startOrcid();

        this.importEmitter = Emitter.subscribe(Events.PROFILE_INFORMATION_IMPORTED, () => this.props.reloadData());
        this.saveEmitter = Emitter.subscribe(Events.PROFILE_INFORMATION_SAVED, () => this.props.reloadData());
    }

    componentWillUnmount() {
        this.importEmitter();
        this.saveEmitter();
    }

    render() {
        const { orcid, ...otherProps } = this.props;

        return <Orcid orcid={orcid} {...otherProps} clickHandler={this.connector.openOrcid} />;
    }
}

export default withPreloading(ProfileOrcid, {
    loadDataFunction: () => (getUser().loggedIn ? middlewareProfile.getProfileInformation() : {}),
    dataMapping: data => ({ orcid: data.orcidId || '' }),
    showSpinner: false,
});
